import auth from './auth';
import divisa from './divisa';
import operadora from './comercio/operadora';
import defaultStore from './default';
import layout from './layout';

export default {
    namespaced: true,
    modules: {
        auth,
        divisa,
        operadora,
        default: defaultStore,
        layout
    },
    actions: {
        clear: function () {
            window.localStorage.clear();
        }
    }
};